import React, { useState, useEffect } from "react";
import {
  Button,
  MenuItem
} from "@material-ui/core";
import classNames from 'classnames'
import { size, clone, map, get, last, filter } from 'lodash'
import { useForm, Controller } from "react-hook-form";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Grid, Stack, Checkbox,   Typography } from '@mui/material'
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import { TextField } from "./form/TextField";
import { GalleryFormFieldLabel } from './GalleryFormFieldLabel'
import { GalleryFormSectionHeading } from './GalleryFormSectionHeading'
import { AddGalleryEventLogoDialog } from './AddGalleryEventLogoDialog'

export const GalleryHideFormField = ({
  classes,
  control,
  setValue,
  getValues,
  setEventGallery,
  field_name_prefix,
  galleryEventOptions,
  optionalLowResPriceChecked,
  openAddGalleryEventLogoDialog,
  handleAddGalleryEventLogo,
  handleOptionalLowResPriceChange,
  handleHideGallery,
  handleCloseCustomGalleryEventLogoDialog
}) => {

  const labelStyling = {
    width: 130,
    fontWeight: 600,
    fontSize: 12,
    color: '#606060',
    display: 'flex',
    alignItems: 'center'
  }

  const inputStyling = {
    display: 'flex',
    padding: '0px 10px',
    background: '#ebebeb',
    width: 253,
    height: 25,
    fontWeight: 400,
    fontSize: 12,
    color: '#606060'
  }
  
  const galleryEventDetailRow = {
    height: 40,
    display: 'flex',
    bottom: 5,
    alignItems: 'center',
    position: 'relative'
  }

  const disabledTextFieldWrapper = {
    width: 215,
    paddingLeft: '10px',
    background: '#ebebeb',
    '& input': {
      top: 2,
      position: 'relative'
    }
  }
  

  return (
    <Grid item xs={ 12 }>
      <Box sx={{ display: 'flex', gap: '10px' }}>
        <GalleryFormFieldLabel label='Publish'/>
        <Typography sx={inputStyling}>
          <Checkbox
            size='small'
            checked={getValues('available_to_purchase')}
            icon={<RadioButtonUncheckedIcon />}
            checkedIcon={<RadioButtonCheckedIcon />}
            onChange={(event) => handleHideGallery(event)}
          />
          <Controller
            name=''
            control={control}
            render={(fieldProps) => (
              <TextField
                type='text'
                disableUnderline
                variant='standard'
                fieldProps={ fieldProps }
                className={ classes.textField }
                placeholder='Uncheck to Hide Gallery'
              />
            )}
          />
        </Typography>
      </Box>
    </Grid>
    )
  }
